export const PROPERTY_IMAGE_PLACEHOLDER =
    'http://csvcus.homeaway.com/rsrcs/cdn-logos/2.12.0/bce/brand/misc/property-image-placeholder.svg';
export const PROPERTY_IMAGE_TEST =
    'https://odis-stage.homeaway.com/odis/listing/61b23864-9f58-48b4-89cc-432cf4de1463.c4.jpg';

export const PHASES_OF_STAY = {
    AFTER_STAY: 'AFTER_STAY',
    ARRIVAL: 'ARRIVAL',
    DEPARTURE: 'DEPARTURE',
    PLANNING_ARRIVAL: 'PLANNING_ARRIVAL',
    POST_BOOKING: 'POST_BOOKING',
    PRE_ARRIVAL: 'PRE_ARRIVAL',
    STAY: 'STAY',
};

export const LOCALES = {
    EN_US: 'en_US',
};
export const UTM_MEDIUM = 'utm_medium';
export const UTM_MEDIUM_EMAIL = 'email';

export const BURN_DISCOUNT = 'BURN_DISCOUNT';

export const APP_NAME = 'STAY_UI';

export const INBOX_URL = '/traveler/th/inbox';

export const RESERVATION_STATUS = {
    UNCONFIRMED_BY_OWNER: 'UNCONFIRMED_BY_OWNER',
};

export const PAYMENT_STAUS = {
    PAID: 'PAID',
};
